module.exports = __webpack_public_path__ + "static/media/46_A.845a65a3.png";